import script from "./area.vue?vue&type=script&lang=js&setup=true"
export * from "./area.vue?vue&type=script&lang=js&setup=true"

import "./area.vue?vue&type=style&index=0&id=28d8c94c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28d8c94c"]])

export default __exports__